:host {
  display: block;
}

.spw-cookies {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: end;
  z-index: 9999;

  &__container {
    background: white;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 100%;
    margin: 12px;
    line-height: 1.5;
    max-height: calc(-24px + 100vh);
    overflow-y: auto;
  }

  &__content,
  &__buttons {
    padding: 16px;
    @include breakpoint(md) {
      padding: 24px;
    }
  }

  &__content {
    padding-bottom: 0;
  }

  &__buttons {
    position: sticky;
    z-index: 10;
    bottom: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    spw-button {
      --spw-button-py-medium: var(--spw-button-py-large);
    }
  }

  &__title {
    font-size: 24px;
    line-height: 1.2;
    color: var(--spw-colors-support-grey-grey-900);
    @apply spw-tw-mb-2;
  }

  &__text {
    color: var(--spw-color-themes-grey-grey-600);
    @apply spw-tw-mb-4;
  }
}

.spw-cookies__checkbox {
  padding-top: 4px;
}

.spw-cookies__checkbox-text {
  color: var(--spw-color-themes-grey-grey-600);
}
